<template>
    <div class="container-fluid pt-4 px-4">
      <div class="bg-light text-center rounded p-4">
          <div class="d-flex align-items-center justify-content-between mb-4">
              <div class="mb-0">{{title}}</div>

              <div v-if="showPagination" style="text-align: right">
                <select v-model="pagination.perPage" style="margin: 10px;">
                  <option v-for="(rowCount, key ) in this.perPageList" :key="key">{{rowCount}}</option>
                </select>

                <button
                  :disabled="pagination.currentPage <= 1"
                  @click="pagination.currentPage--"
                >
                <font-awesome-icon icon="fa-solid fa-chevron-left" />
                </button>
                  Page {{ pagination.currentPage }} of {{ pagination.totalPages }}
                <button
                  :disabled="pagination.currentPage >= pagination.totalPages"
                  @click="pagination.currentPage++"
                >
                <font-awesome-icon icon="fa-solid fa-chevron-right" />
                </button>
              </div>
          </div>
          <div class="table-responsive">
              <table class="table text-start align-middle table-bordered table-hover mb-0 table-striped">
                  <thead>
                    <tr class="text-dark">
                      <template v-for="(field, key) in fields" :key="key">
                        <th @click="setSort(key)" class="sortable">
                          {{field.text}}
                          <template v-if="sortBy === key">
                            <span v-if="sortDesc === true">↑</span>
                            <span v-else-if="sortDesc === false">↓</span>
                          </template>
                        </th>
                      </template>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in paginatedItems" :key="item">
                      <td v-for="(field, key ) in fields" :key="key">
                        <slot :name="`cell(${key})`" :value="item[key]" :item="item">
                          <span class="date-time" v-if="field.renderer">
                            <component
                              v-for="(obj, index) of mapTypeComponents"
                              :key="index"
                              :is="mapTypeComponents[index][key]"
                              v-bind="obj"
                              :row = item
                              :index = key
                              :value = this.format(field,item[key])
                            />
                          </span>
                          <span v-else >
                            <template v-if="key.indexOf('.') !== -1">
                              {{ this.format(field, this.getValueByString(item, key)) }}
                            </template>
                            <template v-else>
                              {{ this.format(field, item[key])}}
                            </template>
                          </span>
                        </slot>
                      </td>
                    </tr>
                  </tbody>
              </table>
          </div>
      </div>
  </div>
</template>

<script>
//import {computed, reactive, watch} from "vue";
import { computed, reactive, watch, ref, defineAsyncComponent } from 'vue';
// Importing  the lodash library 
//import _ from 'lodash';

import { sort } from 'fast-sort';

export default {
  name: 'Summary-table',
  props: {
    title:{type: String},
    data:{type: Array},
    fields:{type: Object},
    showPagination: {type: Boolean, default: true},
    defaultPerPage: {type: Number, default: 10},
    defaultSort: {type: Object}
  },
  components: {},
  data() {
    return {
      perPageList: {
        '3': 3,
        '5': 5,
        '10': 10,
        '25': 25,
        '50': 50,
        '100': 100,
      },
    }
  },
  methods: {
    ucChase(text){
      return (text.charAt(0).toUpperCase() + text.slice(1)).replace('_', ' ');
    },

    formatDate(string, isDateFormat = false) {
      let date;
      if(!isDateFormat){
          date = new Date(string);
      } else {
          date = string;
      }
      // Then specify how you want your dates to be formatted
      return new Intl.DateTimeFormat('default', {dateStyle: 'long'}).format(date);
    },
    formatPrice(string) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'INR'
      });
      return formatter.format(string);
    },
    formatOptions(optionList, value) {
      return optionList[value] || '';
    },

    format(field, value){
      let type = field.type;
      switch(type) { 
        case 'datetime': { 
            let isDateFormat = field.is_date_format || false;
            value = this.formatDate(value, isDateFormat);
            break; 
        } 
        case 'currency': { 
          value = this.formatPrice(value);
          break; 
        } 
        case 'option': { 
          value = this.formatOptions(field.options, value);
          break; 
        }
      }
      return String(value || '');
    },

    getValueByString(o, s){
      s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
      s = s.replace(/^\./, '');           // strip a leading dot
      var a = s.split('.');
      for (var i = 0, n = a.length; i < n; ++i) {
          var k = a[i];
          if (k in o) {
              o = o[k];
          } else {
              return;
          }
      }
      return o;
    },

    baseOnAttribute: function() {
      return 1;
    },
  },
  setup(props) {
    const mapTypeComponents = computed(() => {
      const { fields } = props;
      let mapTypeComponents = [];
      for (const [key, value] of Object.entries(fields)) {
        if(value.renderer){
            mapTypeComponents.push({[key] : defineAsyncComponent(() =>
              import('@/views/'+value.renderer)
            )}); 
        }
      }
      return mapTypeComponents;
    });

    const pagination = reactive({
      currentPage: 1,
      perPage: props.defaultPerPage,
      totalPages: computed(() =>
        Math.ceil(props.data.length / pagination.perPage)
      ),
    });

    const sortBy = props.defaultSort && props.defaultSort.value ? ref(props.defaultSort.value) : ref(null);
    const sortDesc = props.defaultSort && props.defaultSort.order ? ref(props.defaultSort.order) : ref(null);

    const sortedItems = computed(() => {
      const { data } = props;
      if (sortDesc.value === null) return data;
      if (sortDesc.value) {
        return sort(data).desc((a, b) => this.baseOnAttribute(a, b));
      } else {
        return sort(data).asc(sortBy.value);
      }
    });

    const setSort = (key) => {
      if (sortBy.value === key) {
        if (sortDesc.value === true) sortDesc.value = null;
        else if (sortDesc.value === false) sortDesc.value = true;
        else sortDesc.value = false;
      } else {
        sortBy.value = key;
        sortDesc.value = false;
      }
    };

    const paginatedItems = computed(() => {
    const { currentPage, perPage } = pagination;
    const start = (currentPage - 1) * perPage;
    const stop = start + perPage;
      return sortedItems.value.slice(start, stop);
    });

    
    
    watch(
      () => pagination.totalPages,
      () => (pagination.currentPage = 1)
    );
    return {setSort, sortBy, sortDesc, pagination, paginatedItems, mapTypeComponents};
  },
}
</script>